import { buildUrl } from '../../../common/urlBuilder';
import Service from '../../../service';

export const getCountryList = async () => {
  let url = buildUrl('v1/site-management/country');

  return Service.get(url);
};

export const getStateList = async (countryId) => {
  let url = buildUrl('v1/site-management/state');
  if (countryId) url += `?countryId=${countryId}`

  return Service.get(url);
};

export const getAll = async (filteredData) => {
  let url = buildUrl('v1/site-management/city/pagination');
  if (filteredData) url += `?${filteredData}`;

  return Service.get(url);
};

export const findById = async (id) => {
  let url = buildUrl(`v1/site-management/city/${id}`);

  return Service.get(url);
};

export const create = async (data) => {
  let url = buildUrl('v1/site-management/city');

  return Service.post(url, data);
};

export const update = async (data, id) => {
  let url = buildUrl(`v1/site-management/city/${id}`);
  return Service.put(url, data);
};

export const deleteRatePlan = async (id) => {
  let url = buildUrl(`v1/site-management/city/${id}`);
  return Service.delete(url);
};